import { RegistrationBizDataModel, RegistrationDataModel } from '../../_interfaces/registration_response.interface';

export interface OnboardingStateModel {
  step: OnboardingSteps;
  graphic: string;
  showProgress: boolean;
  registerDetails?: RegistrationDataModel;
  businessDetails?: RegistrationBizDataModel;
}

export enum OnboardingSteps {
  LOGIN,
  GET_STARTED,
  BUSINESS_DETAILS,
  VERIFY_EMAIL,
  PASSWORD,
  VERIFY_PHONE,
  SUBSCRIPTION_SELECTION,
  BUSINESS_CERTIFICATE,
  FINAL,
  PASSWORD_REQUEST,
  EMAIL_CHECK,
  DIRECTOR_APPROVAL,
  SUCCESS,
}
